
export default {
  metaInfo() {
    const baseUrl = window.location.protocol + "//" + window.location.host;
    return {
      meta: [
        { property: "og:title", content: this.$t("title") },
        { property: "og:type", content: "website" },
        { vmid: "og:url", property: "og:url", content: baseUrl + this.$route.path },
        {
          property: "og:image",
          content: baseUrl + "/favicon.png",
        },
        { property: "og:image:type", content: "image/jpeg" },
      ],
    };
  },
};